import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { EmailCheck } from "@unisearch/auth/email_check";

const Check = () => {
  return (
    <LayoutMain
      title="Check Email"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/check-email`}
    >
      <EmailCheck />
    </LayoutMain>
  );
};

export default Check;
